import React from 'react'

const BrandsWith = () => {
  return (
    <>
    <h3 style={{fontSize:40, textAlign:'center', color:'#1e1b4b'}}>Brands We Deal With</h3>
    <div className='brand-img'>
       <img src='/images/logo/hiwin.jpg' />
       <img src='/images/logo/limon.jpg' />
       <img src='/images/logo/tlx.png' />
    </div>
    </>
  )
}


export default BrandsWith
